import { render, staticRenderFns } from "./FormPageTouristAgency.vue?vue&type=template&id=483aa196&"
import script from "./FormPageTouristAgency.vue?vue&type=script&lang=js&"
export * from "./FormPageTouristAgency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('483aa196')) {
      api.createRecord('483aa196', component.options)
    } else {
      api.reload('483aa196', component.options)
    }
    module.hot.accept("./FormPageTouristAgency.vue?vue&type=template&id=483aa196&", function () {
      api.rerender('483aa196', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/touristAgency/form/FormPageTouristAgency.vue"
export default component.exports